module.exports = __webpack_public_path__ + "img/image_step_1.c31252e1.png";